module.exports = __webpack_public_path__ + "static/img/home_cmp_02.c5a2ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_cmp_02.png
// module id = XQhn
// module chunks = 9